import { render, staticRenderFns } from "./SDAddressPreview.vue?vue&type=template&id=24f9196e&"
import script from "./SDAddressPreview.vue?vue&type=script&lang=js&"
export * from "./SDAddressPreview.vue?vue&type=script&lang=js&"
import style0 from "./SDAddressPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports